import type React from 'react';

interface SVGIconProps {
    color?: string;
    secondaryColor?: string;
    style?: React.CSSProperties;
}

const defaultStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
};

const ICON_COLORS = {
    primary: '#0f3157',
    secondary: '#ffffff',
    gTK: '#61B7A3',
    gK: '#D5C078',
    g1: '#C3D25A',
    g2: '#EB793F',
    g3: '#2F8467',
    g4: '#A35CA7',
    g5: '#5EA4E8',
    g6: '#ED1C26',
    g6M: '#AA1F2E',
    g7: '#5662AD',
    g8: '#00A079',
};

export function MyLessons_UnselectedIcon({ color, style = defaultStyle }: SVGIconProps) {
    const iconColor =
        typeof color === 'string' && ICON_COLORS[color as keyof typeof ICON_COLORS]
            ? ICON_COLORS[color as keyof typeof ICON_COLORS]
            : color;
    return (
        <svg
            style={style}
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <g stroke={iconColor} fill={iconColor}>
                <circle
                    strokeWidth="7"
                    strokeMiterlimit="10"
                    fill="none"
                    cx="50"
                    cy="50"
                    r="42.5"
                />
                <g className="plus-unselected">
                    <path d="M50,79c-2.21,0-4-1.79-4-4V25c0-2.21,1.79-4,4-4s4,1.79,4,4v50c0,2.21-1.79,4-4,4Z" />
                    <path d="M75,54H25c-2.21,0-4-1.79-4-4s1.79-4,4-4h50c2.21,0,4,1.79,4,4s-1.79,4-4,4Z" />
                </g>
            </g>
        </svg>
    );
}

export function MyLessons_SelectedIcon({ color, style = defaultStyle }: SVGIconProps) {
    const iconColor =
        typeof color === 'string' && ICON_COLORS[color as keyof typeof ICON_COLORS]
            ? ICON_COLORS[color as keyof typeof ICON_COLORS]
            : color;
    return (
        <svg
            style={style}
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <path
                fill={iconColor}
                className="plus-selected"
                d="M50,4C24.59,4,4,24.59,4,50s20.59,46,46,46,46-20.59,46-46S75.41,4,50,4ZM76.47,54h-22.47v22.47c0,2.21-1.79,4-4,4s-4-1.79-4-4v-22.47h-22.47c-2.21,0-4-1.79-4-4s1.79-4,4-4h22.47v-22.47c0-2.21,1.79-4,4-4s4,1.79,4,4v22.47h22.47c2.21,0,4,1.79,4,4s-1.79,4-4,4Z"
            />
        </svg>
    );
}

export function SearchIcon({ color, style = defaultStyle }: SVGIconProps) {
    const iconColor =
        typeof color === 'string' && ICON_COLORS[color as keyof typeof ICON_COLORS]
            ? ICON_COLORS[color as keyof typeof ICON_COLORS]
            : color;
    return (
        <svg
            style={style}
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 1200"
        >
            <path
                fill={iconColor}
                className="search-icon"
                d="m1085.4 1014.6-269.77-269.77h-0.003906c62.656-80.641 92.215-182.13 82.664-283.8-9.5469-101.67-57.492-195.88-134.07-263.44-76.57-67.562-176.02-103.4-278.09-100.21-102.07 3.1875-199.09 45.156-271.29 117.37-72.211 72.207-114.18 169.22-117.37 271.29-3.1875 102.07 32.648 201.52 100.21 278.09 67.562 76.574 161.77 124.52 263.44 134.07 101.67 9.5508 203.16-20.008 283.8-82.664l269.77 269.77c12.703 12.266 30.93 16.922 47.957 12.254 17.027-4.668 30.332-17.973 35-35 4.668-17.027 0.011719-35.254-12.254-47.957zm-885.35-514.65c0-79.566 31.605-155.87 87.867-212.13 56.262-56.262 132.57-87.867 212.13-87.867s155.87 31.605 212.13 87.867c56.262 56.262 87.867 132.57 87.867 212.13s-31.605 155.87-87.867 212.13c-56.262 56.262-132.57 87.867-212.13 87.867-79.539-0.085938-155.79-31.723-212.04-87.965-56.242-56.242-87.879-132.5-87.965-212.04z"
            />
        </svg>
    );
}
